import { AuthenticationService } from '@services/authentication.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, NgZone } from '@angular/core';
import { PopoverService } from '../popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import icPerson from '@iconify/icons-ic/twotone-person';
import theme from '../../utils/tailwindcss';
import { GapiSession } from 'src/infraestructure/sessions/gapi.session';
import { Router } from '@angular/router';
import { AuthService } from 'dvt-lib';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styles: [`.img-circle {
    border-radius: 50px;
    width: 60px;
  }`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {

  dropdownOpen: boolean;
  icPerson = icPerson;
  theme = theme;

  constructor(
    private popover: PopoverService,
    private cd: ChangeDetectorRef,
    private gapiSession: GapiSession, 
    private router: Router, 
    private ngZone: NgZone,
    private authService: AuthService) { }

  nombreUsuario = 'Nombre';
  correoUsuario = 'Correo';
  imagenUsuario = 'assets/img/demo/1.jpg';

  ngOnInit() {
    this.cargarUsuarioEnSesion();
  }

  cargarUsuarioEnSesion() {
    this.authService.usuario$.subscribe((usuario) => {
      if (usuario) {
        this.nombreUsuario = usuario.nombre_usuario+" --- "+usuario.apellidos_usuario;
        this.correoUsuario = usuario.email;
        this.imagenUsuario = usuario.imagen;
      } else {
        console.log("*** usuario sin sesion ***");
      }
    });
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
